// TODO - remove this once we handle https://jira.autodesk.com/browse/BTLV-5673
export const MOCK_ISSUE_TYPE = 'MOCK_ISSUE_TYPE';

export const TYPE_ISSUES = 'issues';
export const TYPE_QUALITY_ISSUES = 'quality_issues';

export const SUPPORTED_ISSUE_MODEL_TYPES = [TYPE_ISSUES, TYPE_QUALITY_ISSUES];

export const ISSUE_TYPES_READ_LIMIT = 9999;

export const ISSUE_TYPES_PERMITTED_ACTIONS = {
  CAN_EDIT: 'edit',
  CAN_DELETE: 'delete',
  CAN_CHANGE_ORDER: 'change_order'
};

export const ISSUE_TYPES_ATTRIBUTES = {
  TITLE: 'title',
  STATUS: 'isActive'
};

export const ISSUE_PERMITTED_ACTIONS = {
  ADD_COMMENT: 'add_comment',
  ADD_ATTACHMENT: 'add_attachment',
  REMOVE_ATTACHMENT: 'remove_attachment',
  ASSIGN_ALL: 'assign_all',
  ASSIGN_SAME_COMPANY: 'assign_same_company',
  ASSIGN_CREATOR_OR_OWNER: 'assign_creator_or_owner',
  CLEAR_ASSIGNEE: 'clear_assignee'
};

export const ISSUE_TYPES_UPDATE_ACTIONS = {
  ISSUE_TYPE: 'ISSUE_TYPE',
  ISSUE_TYPE_MAPPINGS: 'ISSUE_TYPE_MAPPINGS'
};

export const ISSUE_ALL_TYPES_UPDATE_ACTIONS = {
  REQUIRED_FIELDS: 'REQUIRED_FIELDS'
};

export const STATUS_SETS = {
  BASIC: 'basic',
  FIELD: 'field'
};

export const ISSUE_TYPES_STATUS_TYPES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};
